const autoNgTemplateLoaderTemplate1 = require('./betaPanel.html');

angular.module('shbdeployer.app').component('betaPanel', {
  templateUrl: autoNgTemplateLoaderTemplate1,
});
